<template>
  <div>
    <v-list v-for="(item, id) in sekolahs" :key="id" class="pb-0">
      <div :key="id">
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-hospital-building</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="blue--text body-1">
                      {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                    </div>
                    <div class="black--text">
                      <b>NPSN : </b>
                      {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                    </div>
                    <div v-if="item.k_kp_kategori_psp" class="black--text body-2">
                      <span class="font-weight-medium">Kategori: </span>
                      <v-icon left :color="kategoris[item.k_kp_kategori_psp]" class="mr-0">
                        mdi-numeric-{{ item.k_kp_kategori_psp }}-circle
                      </v-icon>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <div class="caption grey--text mb-0">Alamat Sekolah</div>
                    <div class="link black--text body-2">
                      <div>{{ $getDeepObj(item, 'sekolah.data.alamat') || '-' }}</div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <div class="caption grey--text mb-0">Status Pelaporan</div>
                    <div>
                      <v-chip :color="getStatusLaporan(item, 'color')" dark>
                        {{ getStatusLaporan(item, 'label') }}
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <div v-if="meta.is_edit" class="mt-4">
                      <v-btn color="secondary" class="white--text" @click="onEdit(item)">
                        <v-icon left dark>
                          mdi-pencil
                        </v-icon>
                        Ubah Laporan
                      </v-btn>
                    </div>
                    <div v-else class="mt-4">
                      <v-btn
                        color="secondary"
                        class="white--text"
                        :disabled="!($getDeepObj(item, `psp_kp_pa_sekolah_${type}s.data`) || []).length"
                        @click="onEdit(item, true)"
                      >
                        <v-icon left dark>
                          mdi-eye
                        </v-icon>
                        Lihat Detail
                      </v-btn>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
          <v-list-item-action-text>
            <base-list-action
              v-if="false /*Number($getDeepObj(item, `psp_kp_pa_sekolah_${type}s.data.0.is_lengkap`)) === 1*/"
              :data="item"
              :actions="actions"
              :allow="allow"
              @action="onAction"
            />
          </v-list-item-action-text>
        </v-list-item>
        <v-divider v-if="id + 1 < sekolahs.length" />
      </div>
    </v-list>
    <base-modal-full
      ref="modal"
      :title="formulir.title"
      :auto-close="formulir.isPreview"
      :use-save="!formulir.isPreview"
      @save="onSave"
      @close="onClose"
    >
      <component
        ref="formulir"
        :is="formulir.component"
        :psp-kp-pa="pspKpPa"
        :instrumen="formulir.instrumen || []"
        :initValue="formulir.init"
        :berkases="formulir.berkases || []"
        :is-preview="formulir.isPreview"
        @refresh="onRefresh"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import actions from './actions';
import FormulirVisitasi from '../formulir/Visitasi';
import FormulirRefleksi from '../formulir/Refleksi';
import BaseListAction from '@components/base/BaseListAction';

export default {
  name: 'LaporanList',
  components: { FormulirVisitasi, FormulirRefleksi, BaseListAction },
  props: {
    pspKpPa: {
      type: Object,
      default: () => {},
    },
    pspKpPaPendampingan: {
      type: Object,
      default: () => {},
    },
    sekolahs: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'visitasi',
    },
    meta: {
      type: Object,
      default: () => {},
    },
    refleksiBaru: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actions: actions,
      formulir: {},
      pspKpPaSekolahId: '',
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
    };
  },
  computed: {
    labelPspKpPaSekolah() {
      return `psp_kp_pa_sekolah_${this.type}s`;
    },
  },
  methods: {
    ...mapActions('laporan', ['getDetail', 'save']),

    allow(action, data) {
      let allow = false;

      switch (action.event) {
        case 'onEdit':
          allow = Number(this.$getDeepObj(data, `${this.labelPspKpPaSekolah}.data.0.is_lengkap`)) === 1;
          break;
        default:
          allow = this.$allow(action.akses, data.policies);
          break;
      }

      return allow;
    },

    getStatusLaporan(data, target) {
      const pspKpPaSekolah = this.$getDeepObj(data, `psp_kp_pa_sekolah_${this.type}s.data.0`) || {};

      let status = {};
      if (this.type === 'visitasi') {
        status = { label: 'Belum melaporkan', color: 'red' };
        if (!this.refleksiBaru && !this.meta.is_edit) {
          status = { label: 'Tidak ada', color: 'blue' };
        }

        if (this.$isObject(pspKpPaSekolah)) {
          if (+pspKpPaSekolah.is_terlaksana !== 1) {
            status = { label: 'Tidak ada', color: 'blue' };
          } else {
            if (+pspKpPaSekolah.is_lengkap === 1) {
              status = { label: 'Lengkap', color: 'green' };
            } else {
              status = { label: 'Belum lengkap', color: 'orange' };
            }
          }
        }
      } else {
        if (+pspKpPaSekolah.is_lengkap === 1) {
          status = { label: 'Lengkap', color: 'green' };
        } else {
          status = { label: 'Belum lengkap', color: 'orange' };
        }
      }

      return status[target] || '';
    },

    async detailData() {
      const pspKpPaPendampinganId = this.pspKpPaPendampingan && this.pspKpPaPendampingan['psp_kp_pa_pendampingan_id'];
      const endpoint = this.type === 'visitasi' ? 'sekolah-visitasi' : 'sekolah';
      const attr = { endpoint: `pendampingan-lingkup/${pspKpPaPendampinganId}/${endpoint}` };
      const id = this.pspKpPaSekolahId;
      const resp = await this.getDetail({ attr, id });

      return resp || {};
    },

    validateDescription(type) {
      let error = '';
      let keysWordCount = ['praktik_baik', 'peningkatan', 'rencana_sekolah', 'rencana_pa'];
      let labels = {
        tema: 'Tema refleksi',
        praktik_baik: 'Praktik baik yang tergali saat refleksi',
        peningkatan: 'Hal yang perlu ditingkatkan oleh Kepala Sekolah dan Guru',
        rencana_sekolah: 'Rencana tindak lanjut sekolah',
        rencana_pa: 'Rencana tindak lanjut Fasilitator Sekolah Penggerak',
      };

      if (type === 'visitasi') {
        keysWordCount = ['kendala', 'rencana', 'pertanyaan'];
        labels = {
          kendala: 'kendala yang dialami Sekolah',
          rencana: 'Rencana tindak lanjut',
          pertanyaan: 'Pertanyaan yang sering muncul selama kegiatan (terkait kurikulum, BOS dan lain sebagainya)',
        };
      }

      const params = this.$refs.formulir.getValue();
      for (const key of keysWordCount) {
        if (!error && params[key] && (this.$wordCount(params[key]) < 150 || this.$wordCount(params[key]) > 300)) {
          error = key;
        }
      }

      if (error) {
        return `${labels[error]} harus terisi antara 150 - 300 kata`;
      }

      return error;
    },

    onAction({ event, data }) {
      switch (event.event) {
        case 'onEdit':
          this.onEdit(data);
          break;
      }
    },

    async onEdit(data, isPreview = false) {
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'berkases', null);

      // get detail data
      this.pspKpPaSekolahId = data.psp_kp_pa_sekolah_id;
      const detail = await this.detailData();
      const detailData = detail.data || {};
      const detailMeta = detail.meta || {};

      // type (refleksi / visitasi)
      const instrumen = this.$getDeepObj(detailMeta, `instrumen`) || [];
      const pspKpPaSekolahDetail = this.$getDeepObj(data, `psp_kp_pa_sekolah_${this.type}s.data.0`) || {};
      const berkases = this.$getDeepObj(detailData, `psp_kp_pa_sekolah_${this.type}_berkases.data`) || [];
      const pendampinganKe = this.pspKpPaPendampingan['pendampingan_ke'] || '';
      const init = {
        pspKpPaSekolahDetail,
        pspKpPaSekolahId: this.pspKpPaSekolahId,
        pspKpPaPendampingan: this.pspKpPaPendampingan,
        jadwal: this.$getDeepObj(this.config, `pendampingan_ke-${this.type}.${pendampinganKe}`) || '',
        sekolah: data.sekolah || {},
        detail: detailData,
      };

      const titles = {
        visitasi: 'Laporan Kunjungan Lapangan',
        refleksi: 'Laporan Refleksi Satuan Pendidikan',
      };
      const forms = {
        visitasi: 'FormulirVisitasi',
        refleksi: 'FormulirRefleksi',
      };

      this.$set(this.formulir, 'title', titles[this.type]);
      this.$set(this.formulir, 'component', forms[this.type]);
      this.$set(this.formulir, 'instrumen', instrumen);
      this.$set(this.formulir, 'isPreview', isPreview);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
        this.$set(this.formulir, 'berkases', berkases);
      });
    },

    onSave() {
      const pspKpPaPendampinganId = this.pspKpPaPendampingan.psp_kp_pa_pendampingan_id;
      const pspKpPaSekolahId = this.$getDeepObj(this.formulir, 'init.pspKpPaSekolahId');
      const action = this.type === 'visitasi' ? 'update-visitasi' : 'update';
      const endpoint = `pendampingan-lingkup/${pspKpPaPendampinganId}/${action}/${pspKpPaSekolahId}`;
      const params = this.$refs.formulir.getValue();

      this.$refs.modal.loading = false;

      // validate description question
      const errorDsc = this.validateDescription(this.type);
      if (errorDsc) {
        this.$error(`Isian ${errorDsc} harus terisi antara 150 - 300 kata`);
        this.$refs.modal.loading = false;
        return;
      }

      this.save({ endpoint, params })
        .then(() => {
          this.$emit('refresh');
          this.$success('Laporan berhasil disimpan');
          this.$refs.modal.dialog = false;
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onClose() {
      if (this.formulir.isPreview) {
        this.$refs.modal.close();
        return;
      }

      this.$confirm(
        `<h3>Anda yakin ingin keluar dari halaman ini?</h3><p>Data yang belum tersimpan akan hilang jika Anda keluar dari halaman ini</p>`,
        `Keluar dari Formulir Isian`,
        {
          tipe: 'error',
        }
      ).then(() => {
        if (this.$refs?.modal) this.$refs.modal.dialog = false;
      });
    },

    async onRefresh() {
      const detail = await this.detailData();
      const berkases = this.$getDeepObj(detail.data, `psp_kp_pa_sekolah_${this.type}_berkases.data`) || [];

      this.$emit('refresh');
      this.$set(this.formulir, 'berkases', berkases);
    },
  },
};
</script>

<style scoped></style>
